<template>
    <div class="mt-2">
        <v-layout row>
            <v-flex xs3>
                <v-card class="pa-4 ma-3">
                    <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>

                    <div v-if="account">
                        <!-- <v-card-title
                            class="text-xs-center headline px-0 mb-2 pt-0 mb-3 pb-0"
                        >
                            Office Section
                        </v-card-title> -->

                        <div style="border: 1px solid #43a047;" class="">
                            <v-layout
                                row
                                style="background-color: #43a047; color: #fff;"
                                class="pa-2"
                            >
                                <div
                                    class="subheading-2 pt-1 font-weight-regular"
                                >
                                    VOTER REGISTRATION
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="ml-2 my-0"
                                    small
                                    style="color: #4caf50; background-color: #FFF"
                                    @click="openVotingModal"
                                    >Update</v-btn
                                >
                            </v-layout>

                            <div class="mx-2 pt-2">
                                <div class="font-weight-medium mr-2">
                                    Voting Registration Status:
                                </div>
                                {{ getVotingStatus() }}
                            </div>
                            <div
                                class="ml-2"
                                v-if="votingInfo && votingInfo.note"
                            >
                                {{ "Note: " + votingInfo.note }}
                            </div>

                            <v-divider class="mt-2"></v-divider>

                            <div class="mx-2 py-2">
                                <div class="font-weight-medium mr-2">
                                    Matches: ({{ votingMatches.length }})
                                </div>
                                <div v-for="match in votingMatches">
                                    <div>
                                        {{
                                            match.first +
                                                " - " +
                                                match.matchType
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div class="mx-2 py-2">
                                <div class="font-weight-medium mr-2">
                                    Registration Forms: ({{ regForms.length }})
                                </div>
                                <div v-for="form in regForms">
                                    <div
                                        style="color: #4caf50; cursor: pointer;"
                                        @click="openAddRegistrationForm(form)"
                                    >
                                        {{ form.name + " - " + form.type }}
                                    </div>
                                </div>
                            </div>

                            <!-- <v-btn
                            class="ma-2 mb-3"
                            small
                            color="success"
                            @click="openAddRegistrationForm(null)"
                            >Add Registration Form</v-btn
                        > -->
                        </div>

                        <!-- <v-select
                            color="success"
                            :items="statusList"
                            v-model="application.status"
                            class="mb-0 mt-3"
                            label=""
                        ></v-select> -->
                        <v-textarea
                            class="mt-3"
                            autocomplete="new-password"
                            label="Note"
                            outline
                            rows="5"
                            v-model="application.note"
                            ref="note"
                            hide-details
                        ></v-textarea>

                        <v-btn
                            @click="openEmailDialog"
                            :disabled="isClosed()"
                            small
                            color="success"
                            class="mt-4"
                            >Send Application Email</v-btn
                        >

                        <v-card-actions class="ml-0 mr-0 mt-3 pb-0">
                            <v-btn
                                color="success"
                                :loading="processing"
                                @click="save"
                                :disabled="isClosed()"
                            >
                                Save
                            </v-btn>
                            <v-btn dark color="default" @click="cancel"
                                >Cancel</v-btn
                            >
                        </v-card-actions>
                    </div>
                </v-card>
            </v-flex>
            <v-flex xs9>
                <v-card class="pa-4 ma-3">
                    <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <div v-if="!loading && account">
                        <v-layout align-center justify-center>
                            <v-card-title
                                class="text-xs-center headline px-0 mb-2 pt-0 mb-3 pb-0"
                            >
                                New Family Application
                            </v-card-title>
                        </v-layout>
                        <v-form ref="form">
                            <div>
                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Last Name"
                                        v-model="applicationForm.lastName"
                                        ref="lastName"
                                        class="ml-3"
                                        :rules="required"
                                        v-bind:class="{
                                            'vm-form-error': invalid(
                                                'lastName',
                                            ),
                                        }"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="First Name"
                                        v-model="applicationForm.firstName"
                                        ref="firstName"
                                        :rules="required"
                                        class="ml-3"
                                        v-bind:class="{
                                            'vm-form-error': invalid(
                                                'firstName',
                                            ),
                                        }"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="לעצטע נאמען"
                                        v-model="applicationForm.lastNameH"
                                        ref="lastNameH"
                                        :rules="required"
                                        class="ml-3"
                                        v-bind:class="{
                                            'vm-form-error': invalid(
                                                'lastNameH',
                                            ),
                                        }"
                                        reverse
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="ערשטע נאמען"
                                        v-model="applicationForm.firstNameH"
                                        ref="firstNameH"
                                        :rules="required"
                                        v-bind:class="{
                                            'vm-form-error': invalid(
                                                'firstNameH',
                                            ),
                                        }"
                                        class="ml-3"
                                        reverse
                                    ></v-text-field>
                                </v-layout>
                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Mothers Name"
                                        v-model="applicationForm.mothersName"
                                        ref="mothersName"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="מאמע'ס אידישע נאמען"
                                        v-model="applicationForm.mothersNameHeb"
                                        ref="mothersNameHeb"
                                        class="ml-3"
                                        reverse
                                    ></v-text-field>
                                </v-layout>
                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="שווער"
                                        v-model="applicationForm.fatherInLaw"
                                        ref="fatherInLaw"
                                        class="ml-3"
                                        reverse
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="טאטע"
                                        v-model="applicationForm.father"
                                        ref="father"
                                        class="ml-3"
                                        reverse
                                    ></v-text-field>
                                </v-layout>

                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Address"
                                        v-model="applicationForm.address1"
                                        ref="address1"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Zipcode"
                                        v-model="applicationForm.zipcode"
                                        ref="zipcode"
                                        class="ml-3"
                                        @input="fillCityState"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="City"
                                        v-model="applicationForm.city"
                                        ref="city"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="State"
                                        v-model="applicationForm.state"
                                        ref="state"
                                        class="ml-3"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Email Address"
                                        v-model="applicationForm.emailAddress"
                                        v-bind:class="{
                                            'vm-form-error': invalid(
                                                'emailAddress',
                                            ),
                                        }"
                                        ref="emailAddress"
                                        class="ml-3"
                                    ></v-text-field>
                                </v-layout>

                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Mother Cell"
                                        v-model="applicationForm.motherCell"
                                        ref="motherCell"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Cell Phone"
                                        v-model="applicationForm.cellPhone"
                                        ref="cellPhone"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Home Phone"
                                        v-model="applicationForm.homePhone"
                                        ref="homePhone"
                                        class="ml-3"
                                    ></v-text-field>
                                </v-layout>

                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-spacer></v-spacer>
                                    <v-select
                                        :disabled="isClosed()"
                                        color="success"
                                        :items="workTypes"
                                        v-model="applicationForm.workType"
                                        class="my-0"
                                        reverse
                                        style="max-width: 300px"
                                        label="Work Type"
                                    ></v-select
                                ></v-layout>

                                <v-layout
                                    row
                                    justify-end
                                    align-end
                                    class="mx-3"
                                >
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="נאמען פון בעה''ב / ארבעט"
                                        v-model="
                                            applicationForm.workPlaceOrBoss
                                        "
                                        ref="workPlaceOrBoss"
                                        class="ml-3"
                                        reverse
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Work Phone"
                                        v-model="applicationForm.workPhone"
                                        ref="workPhone"
                                        class="ml-3"
                                    ></v-text-field>
                                    <v-text-field
                                        :disabled="isClosed()"
                                        autocomplete="new-password"
                                        label="Work Address"
                                        v-model="applicationForm.workAddress"
                                        ref="workAddress"
                                        class="ml-3"
                                    ></v-text-field>
                                </v-layout>
                            </div>
                        </v-form>
                    </div>
                </v-card>

                <v-card class="pa-4 ma-3">
                    <v-progress-linear
                        v-if="loadingStudents"
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                    <v-layout
                        column
                        align-center
                        justify-center
                        v-if="!loadingStudents"
                    >
                        <v-card-title
                            class="text-xs-center headline px-0 mb-2 pt-0 mb-3 pb-0"
                        >
                            Students
                        </v-card-title>
                        <v-btn
                            :disabled="isClosed()"
                            v-if="!newStudents.length"
                            class="my-0"
                            color="success"
                            @click="addStudent"
                            >Add Student</v-btn
                        >
                    </v-layout>

                    <div
                        v-for="(student, index) in newStudents"
                        v-if="!loadingStudents"
                    >
                        <v-form ref="studentForm">
                            <v-layout
                                row
                                justify-end
                                align-end
                                class="mx-3 mb-2"
                            >
                                <v-btn
                                    :disabled="isClosed()"
                                    small
                                    color="default"
                                    dark
                                    class="mr-2"
                                    @click="removeStudent(index)"
                                    >Remove Student</v-btn
                                >
                                <v-btn
                                    :disabled="isClosed()"
                                    small
                                    color="success"
                                    @click="addStudent"
                                    >Add Student</v-btn
                                >
                            </v-layout>
                            <v-layout
                                row
                                justify-end
                                align-end
                                class="mx-3 mb-2"
                            >
                                <v-text-field
                                    :disabled="isClosed()"
                                    autocomplete="new-password"
                                    label="אידישע נאמען"
                                    v-model="student.hebName"
                                    ref="studentHebName"
                                    class="ml-3"
                                    :rules="required"
                                    v-bind:class="{
                                        'vm-form-error': invalidStudent(
                                            'studentHebName',
                                            index,
                                        ),
                                    }"
                                    reverse
                                ></v-text-field>
                                <v-text-field
                                    :disabled="isClosed()"
                                    autocomplete="new-password"
                                    label="English Name"
                                    v-model="student.engName"
                                    ref="studentEngName"
                                    :rules="required"
                                    v-bind:class="{
                                        'vm-form-error': invalidStudent(
                                            'studentEngName',
                                            index,
                                        ),
                                    }"
                                    class="ml-3"
                                ></v-text-field>
                                <v-menu
                                    v-model="student.dobPickerMenu"
                                    :close-on-content-click="false"
                                    offset-y
                                    full-width
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :disabled="isClosed()"
                                            class="ml-3"
                                            v-model="student.dob"
                                            :value="student.dob"
                                            label="Date Of Birth"
                                            readonly
                                            ref="studentDOB"
                                            :rules="required"
                                            v-bind:class="{
                                                'vm-form-error': invalidStudent(
                                                    'studentDOB',
                                                    index,
                                                ),
                                            }"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="student.dob"
                                        @change="dateOfBirthChanged(student)"
                                    ></v-date-picker>
                                </v-menu>
                                <v-radio-group
                                    v-model="student.gander"
                                    row
                                    class="ml-3"
                                    :disabled="isClosed()"
                                >
                                    <v-radio
                                        label="אינגעל"
                                        value="male"
                                        color="success"
                                    ></v-radio>
                                    <v-radio
                                        label="מיידל"
                                        value="female"
                                        color="success"
                                    ></v-radio>
                                </v-radio-group>
                            </v-layout>
                            <v-layout
                                row
                                justify-end
                                align-end
                                class="mx-3 mb-2"
                            >
                                <v-layout
                                    row
                                    class="pb-3"
                                    style="max-width: fit-content;"
                                    v-if="student.dob"
                                >
                                    <div class="font-weight-medium mr-2">
                                        Allowed Start Date:
                                    </div>
                                    <div>
                                        {{ getMinStartDate(student) | date }}
                                    </div>
                                </v-layout>
                                <v-menu
                                    v-model="student.startDatePickerMenu"
                                    :close-on-content-click="true"
                                    offset-y
                                    full-width
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            class="ml-3"
                                            v-model="student.startDate"
                                            :value="student.startDate"
                                            label="Start Date"
                                            :disabled="isClosed()"
                                            readonly
                                            ref="startDate"
                                            :rules="required"
                                            v-bind:class="{
                                                'vm-form-error': invalidStudent(
                                                    'startDate',
                                                    index,
                                                ),
                                            }"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        :min="student.minStartDate"
                                        v-model="student.startDate"
                                    ></v-date-picker>
                                </v-menu>

                                <v-select
                                    color="success"
                                    :items="years"
                                    v-model="student.year"
                                    :disabled="isClosed()"
                                    class="my-0 ml-3"
                                    reverse
                                    style="max-width: 200px"
                                    label="Year"
                                ></v-select>

                                <v-select
                                    color="success"
                                    :items="getGrades(student)"
                                    :disabled="isClosed()"
                                    v-model="student.classDescription"
                                    class="my-0 ml-3"
                                    reverse
                                    style="max-width: 300px"
                                    label="Grade"
                                ></v-select>
                            </v-layout>
                        </v-form>
                        <v-divider
                            class="mb-3"
                            v-if="index + 1 < newStudents.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog persistent v-model="sendEmailDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 px-2"
                    >Send Application Email</v-card-title
                >
                <v-text-field
                    label="Email Address"
                    v-model="toEmail"
                    ref="toEmail"
                    class="mb-2 px-2"
                    :rules="[rules.email, rules.required]"
                ></v-text-field>
                <v-checkbox
                    v-model="saveEmail"
                    label="Save Email Address"
                    color="success"
                    class="px-2 mt-0"
                    hide-details
                ></v-checkbox>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="sendEmailDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="sendEmail()"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addRegFormDialog" max-width="400">
            <voting-reg-form
                ref="regFormDialog"
                :form="clickedRegForm"
                :person="presonInfo"
                :reload="loadApplication"
                :close="closeAddRegistrationForm"
            ></voting-reg-form>
        </v-dialog>

        <v-dialog v-model="updateVotingStatusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-0 pb-2 pl-0">
                    Update Voting Registration Status
                </v-card-title>
                <v-select
                    :items="accountStatuses"
                    v-model="accountStatus"
                    label="Account Status"
                    clearable
                ></v-select>
                <v-textarea
                    v-model="accountStatusNote"
                    label="Note"
                    rows="2"
                ></v-textarea>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateVotingStatusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="processing"
                        @click="saveAccountStatus()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="matchDialog" max-width="1000">
            <voting-master-list-person
                :person="presonInfo"
                :reload="loadApplication"
                :close="closeMatchDialog"
            ></voting-master-list-person>
        </v-dialog>
    </div>
</template>
<script>
import {
    formatPhoneNumber,
    except,
    toTitleCase,
    onlyUnique,
} from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";
import votingRegForm from "../Votes/VotingRegForm.vue";
import votingMasterListPerson from "../Votes/VotingMasterListPerson.vue";

export default {
    components: {
        votingRegForm,
        votingMasterListPerson,
    },
    data() {
        return {
            account: "",
            vmFormDialog: false,
            vmFormDialogWidth: "800",
            processing: false,
            uploading: false,
            loading: true,
            loadingStudents: true,
            files: [],
            vmForms: [],
            vmFormsMessages: [],
            application: "",
            account: "",
            contactInfo: "",
            newStudents: "",
            workTypes: [],
            sendEmailDialog: false,
            toEmail: "",
            saveEmail: false,
            statusList: [],
            votingMatches: [],
            regForms: [],
            votingInfo: {},
            addRegFormDialog: false,
            clickedRegForm: {},
            clickedPerson: {},
            presonInfo: {},
            votingPerson: {},
            updateVotingStatusDialog: false,
            accountStatus: "",
            accountStatusNote: "",
            accountStatuses: [
                "Registered",
                "Don’t Want To Registrar",
                "Waiting For Application",
                "Received Application ",
            ],

            matchDialog: false,

            required: [(value) => !!value || "Required."],

            rules: {
                required: (value) => !!value || "Required.",
                email: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return !value || pattern.test(value) || "Invalid e-mail.";
                },
            },

            pdfDucmentNumberOfPages: "",

            grades: [],
            gradeTerms: [],
            years: [],

            pageCount: 0,
            currentPage: 0,

            verifyForm: false,
            isApplicant: false,

            applicationForm: {
                firstName: "",
                lastName: "",
                firstNameH: "",
                lastNameH: "",
                emailAddress: "",
                mothersName: "",
                mothersNameHeb: "",
                address1: "",
                city: "",
                state: "",
                zipcode: "",
                homePhone: "",
                cellPhone: "",
                father: "",
                fatherInLaw: "",
                motherCell: "",
                landlord: "",
                workPlaceOrBoss: "",
                workPhone: "",
                workAddress: "",
                workType: "",
                receivesKollelPayment: "",
            },
        };
    },
    async created() {
        await this.loadGrades();
        await this.loadGradeTerms();
        await this.loadApplication();

        this.loadWorkTypes();
        this.loadStatusList();

        //this.loadStrings();
    },
    computed: {},
    methods: {
        async loadApplication() {
            const response = await this.$http.get(
                "api/newFamilyApplications/getApplication?accountID=" +
                    this.$route.params.id,
            );

            this.application = response.application;
            this.account = response.account;
            this.contactInfo = response.contactInfo;
            this.votingMatches = response.matches;
            this.regForms = response.regForms;
            this.votingInfo = response.votingInfo;
            this.presonInfo = response.presonInfo;
            this.toEmail = this.account.emailAddress;
            this.votingPerson = response.votingPerson;

            this.isApplicant = this.application.isApplicant;

            console.log(this.isClosed());

            this.fillForm(response.newStudents);

            this.loading = false;
            this.loadingStudents = false;
        },
        isClosed() {
            return !this.isApplicant;
        },
        async loadWorkTypes() {
            this.workTypes = await this.$http.get(
                "api/newFamilyApplications/getWorkTypes",
            );
        },
        async loadStatusList() {
            this.statusList = (await loadOptions(
                "NewFamilyApplicationStatus",
            )).map((c) => c.value);
        },
        async loadGradeTerms() {
            this.gradeTerms = await this.$http.get(
                "api/newFamilyApplications/GetGradeTerms",
            );
            this.years = this.gradeTerms
                .map((g) => g.yearDisplay)
                .filter(onlyUnique);
        },
        async openAddRegistrationForm(row = null) {
            //if (!this.presonVotingInfo) return;

            this.clickedRegForm = row ? row : {};
            this.addRegFormDialog = true;

            if (this.$refs.regFormDialog) {
                this.$refs.regFormDialog.resetValidation();
            }
        },
        closeAddRegistrationForm() {
            this.addRegFormDialog = false;
        },
        getVotingStatus() {
            if (this.votingInfo && this.votingInfo.accountStatus)
                return this.votingInfo.accountStatus;

            if (
                (this.votingMatches.some((m) => m.matchType == "Husband") ||
                    this.regForms.some((m) => m.type == "Husband")) &&
                (this.votingMatches.some((m) => m.matchType == "Wife") ||
                    this.regForms.some((m) => m.type == "Wife"))
            )
                return "OK";

            return "NOT OK";
        },
        openVotingModal() {
            // this.accountStatus = this.votingInfo
            //     ? this.votingInfo.accountStatus
            //     : "";
            // this.accountStatusNote = this.votingInfo
            //     ? this.votingInfo.note
            //     : "";

            // this.presonInfo.accountStatus = this.accountStatus;
            // this.presonInfo.accountStatusNote = this.accountStatusNote;

            //this.updateVotingStatusDialog = true;
            this.matchDialog = true;
        },
        formatPhoneNumber(phone) {
            return formatPhoneNumber(phone);
        },
        getMessage(key) {
            if (!this.vmFormsMessages.length) return;

            return this.vmFormsMessages.find((m) => m.key == key).value;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            // this.uploading = true;
            // const files = e.target.files;
            // if (!files) return;
            // try {
            //     var formData = new FormData();
            //     this.files = files;
            //     formData.append("upload_file", this.files[0]);
            //     const response = await this.$http.post(
            //         "api/kollelForms/uploadKollelApplication?accountID=" +
            //             this.account.accountID,
            //         formData,
            //         {
            //             headers: {
            //                 "Content-Type": "multipart/form-data",
            //             },
            //         }
            //     );
            //     this.kollelApplication.documentURL = response;
            //     this.uploading = false;
            // } catch (e) {
            //     this.uploading = false;
            // }
        },
        openDocument() {
            //window.open(this.kollelApplication.documentURL);
        },
        deleteDocument() {
            this.kollelApplication.documentURL = "";
        },
        async fillForm(newStudents) {
            this.applicationForm.firstName = this.account.firstName;
            this.applicationForm.firstNameH = this.account.firstNameH;
            this.applicationForm.lastName = this.account.lastName;
            this.applicationForm.lastNameH = this.account.lastNameH;
            this.applicationForm.emailAddress = this.account.emailAddress;
            this.applicationForm.father = this.contactInfo.father;
            this.applicationForm.fatherInLaw = this.contactInfo.fatherInLaw;
            this.applicationForm.address1 = this.contactInfo.address1;
            this.applicationForm.city = this.contactInfo.city;
            this.applicationForm.state = this.contactInfo.state;
            this.applicationForm.zipcode = this.contactInfo.zipCode;
            this.applicationForm.homePhone = this.contactInfo.homePhone;
            this.applicationForm.cellPhone = this.contactInfo.cellPhone;
            this.applicationForm.landlord = this.application.landlord;
            this.applicationForm.mothersName = this.application.mothersName;
            this.applicationForm.mothersNameHeb = this.application.mothersNameHeb;
            this.applicationForm.motherCell = this.application.motherCell;
            this.applicationForm.workPlaceOrBoss = this.application.workPlaceOrBoss;
            this.applicationForm.workType = this.application.workType;
            this.applicationForm.workPhone = this.application.workPhone;
            this.applicationForm.workAddress = this.application.workAddress;
            this.applicationForm.receivesKollelPayment = this.application
                .receivesKollelPayment
                ? "יא"
                : "ניין";

            this.newStudents = newStudents.map((student) => {
                const startDate = moment(student.dob).add(32, "month");

                return {
                    id: student.id,
                    engName: student.engName,
                    hebName: student.hebName,
                    dob: new Date(student.dob).toISOString().substr(0, 10),
                    class: student.class,
                    classDescription: this.grades.find(
                        (g) => g.grade == student.class,
                    )
                        ? this.grades.find((g) => g.grade == student.class)
                              .description
                        : "",
                    startDate: new Date(student.startDate)
                        .toISOString()
                        .substr(0, 10),
                    gander:
                        student.class && student.class.startsWith("B")
                            ? "male"
                            : "female",
                    minStartDate: moment(startDate).format(
                        "YYYY-MM-DD HH:mm:ss",
                    ),
                    dobPickerMenu: false,
                    startDatePickerMenu: false,
                    year: this.getYear(student),
                    regID: student.regID,
                };
            });

            // if (!this.newStudents.length) {
            //     this.addStudent();
            // }

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            this.vmFormDialog = true;
        },
        addStudent() {
            this.newStudents.push({
                engName: "",
                hebName: "",
                dob: "",
                class: "",
                classDescription: "",
                startDate: "",
                gander: "male",
                minStartDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                dobPickerMenu: false,
                startDatePickerMenu: false,
            });
        },
        removeStudent(index) {
            //if (index == 0) return;

            this.newStudents.splice(index, 1);
        },
        async loadGrades() {
            const response = await this.$http.get(
                "api/newFamilyApplications/getGradesToApply",
            );

            this.grades = response;
        },
        getGrades(student) {
            if (!this.grades) return;

            return this.grades
                .filter((g) =>
                    student.gander == "male"
                        ? g.grade.startsWith("B")
                        : !g.grade.startsWith("B"),
                )
                .map((a) => a.description);
        },
        dateOfBirthChanged(student) {
            const startDate = moment(student.dob).add(32, "month");

            student.minStartDate = moment(startDate).format(
                "YYYY-MM-DD HH:mm:ss",
            );
            student.startDate = new Date(startDate).toISOString().substr(0, 10);
        },
        getMinStartDate(student) {
            return student.minStartDate;
        },
        async loadStrings() {
            this.vmFormsMessages = await this.$http.get(
                "api/vmForms/getStrings",
            );
        },
        collectFormData() {
            return {
                user: this.$store.state.authentication.user,
                account: {
                    accountID: this.account.accountID,
                    firstName: this.applicationForm.firstName,
                    firstNameH: this.applicationForm.firstNameH,
                    lastName: this.applicationForm.lastName,
                    lastNameH: this.applicationForm.lastNameH,
                    emailAddress: this.applicationForm.emailAddress,
                },
                contactInfo: {
                    address1: this.applicationForm.address1,
                    city: this.applicationForm.city,
                    state: this.applicationForm.state,
                    zipcode: this.applicationForm.zipcode,
                    homePhone: this.applicationForm.homePhone,
                    cellPhone: this.applicationForm.cellPhone,
                    father: this.applicationForm.father,
                    fatherInLaw: this.applicationForm.fatherInLaw,
                },
                newAccountApplication: {
                    applicationID: this.application.applicationID,
                    note: this.application.note,
                    status: this.application.status,
                    mothersName: this.applicationForm.mothersName,
                    mothersNameHeb: this.applicationForm.mothersNameHeb,
                    motherCell: this.applicationForm.motherCell,
                    landlord: this.applicationForm.landlord,
                    workPlaceOrBoss: this.applicationForm.workPlaceOrBoss,
                    workAddress: this.applicationForm.workAddress,
                    workPhone: this.applicationForm.workPhone,
                    workType: this.applicationForm.workType,
                    receivesKollelPayment:
                        this.applicationForm.receivesKollelPayment == "יא",
                },
                newStudents: this.newStudents.map((student) => ({
                    id: student.id,
                    applicationID: this.application.applicationID,
                    //date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    engName: student.engName,
                    hebName: student.hebName,
                    dob: moment(student.dob).format("L"),
                    startDate: moment(student.startDate).format("L"),
                    regID: this.getRegID(student),
                    class: this.grades.find(
                        (g) => g.description == student.classDescription,
                    ).grade,
                })),
            };
        },
        getRegID(student) {
            if (!student.year) return;

            return this.gradeTerms.find((g) => g.yearDisplay == student.year)
                .regID;
        },
        getYear(student) {
            if (!student.regID) return;

            return this.gradeTerms.find((g) => g.regID == student.regID)
                .yearDisplay;
        },
        invalid(field) {
            if (!this.$refs[field]) return;

            return !this.$refs[field].validate();
        },
        invalidStudent(field, index) {
            if (!this.$refs[field]) return;

            if (index === undefined) return;
            if (!this.$refs[field][index]) return;

            return !this.$refs[field][index].validate();
        },
        cancel() {
            this.$router.push({
                name: "NewFamilyApplications",
            });
        },
        async save() {
            if (!this.$refs.form.validate(true)) return;
            if (
                this.newStudents.length &&
                !this.$refs.studentForm.some((s) => s.validate(true))
            )
                return;
            if (
                this.newStudents.some(
                    (s) => moment(s.startDate) < moment(s.minStartDate),
                )
            ) {
                this.$notify({
                    text: "Invalid Student Start Date",
                    group: "notification",
                    type: "error",
                });
                return;
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/newFamilyApplications/Save",
                    this.collectFormData(),
                );

                this.processing = false;

                this.$notify({
                    text: "Application Saved",
                    group: "notification",
                    type: "success",
                });

                // this.$router.push({
                //     name: "NewFamilyApplications",
                // });
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        async fillCityState(zipcode) {
            if (!zipcode || zipcode.length < 5) return;

            const response = await this.$http.get(
                "api/newFamilyApplications/GetCityStateByZipcode?zipcode=" +
                    zipcode,
            );

            if (!response) return;

            this.applicationForm.city = response.city;
            this.applicationForm.state = response.state;
        },
        openEmailDialog() {
            this.sendEmailDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.toEmail.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post(
                    "api/newFamilyApplications/SendApplicationEmail",
                    {
                        user: this.$store.state.authentication.user,
                        accountID: this.account.accountID,
                        emailAddress: this.toEmail,
                        saveEmail: this.saveEmail,
                    },
                );

                if (this.saveEmail) {
                    this.applicationForm.emailAddress = this.toEmail;
                }

                this.processing = false;
                this.sendEmailDialog = false;

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        closeMatchDialog() {
            this.matchDialog = false;
        },
        async saveAccountStatus() {
            //if (!this.$refs.accountStatus.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/voting/saveAccountSettings", {
                    personID: this.application.personID,
                    accountStatus: this.accountStatus,
                    note: this.accountStatusNote,
                });

                this.clickedPerson.accountStatus = this.accountStatus;
                this.updateVotingStatusDialog = false;
                this.loadApplication();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.card-width {
    max-width: 65%;
}
.vm-form-error .error--text {
    color: #f55a4e !important;
    font-weight: 700 !important;
}
.vm-form-error .v-input__slot::after {
    border-color: #f55a4e !important;
    border-width: 3px !important;
}
</style>
